import { render, staticRenderFns } from "./DrugAlternatives.vue?vue&type=template&id=0b5a9c9a&lang=pug"
import script from "./DrugAlternatives.vue?vue&type=script&lang=js"
export * from "./DrugAlternatives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports